module.exports = __webpack_public_path__ + "static/media/spinner-darkbg-l.47646743.gif";